module.exports = __webpack_public_path__ + "static/media/wflogo.c2355383.svg";